import React from 'react';
import { slideWrapper } from '../components/slide';
import { SantaPresenterSolution } from '../components/santa-presenter-solution';
import { RoundLetters, RoundType } from '@disco/data';

export const LibraryPuzzle7Solution = slideWrapper(
  ({ step, getImg, countingResults, countingResultsLoading }) => {
    const { answers } = step;

    return (
      <>
        <SantaPresenterSolution
          {...{ countingResults, countingResultsLoading, getImg, answers, letters: RoundLetters[4] }}
        />
      </>
    );
  },
  { countSantaAnswersTour: RoundType.Library }
);
